import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import CompanyList from "./CompanyList";
import { ModalPickerProps } from "../props";
import RemovableCompany from "components/Removables/RemovableCompany";
import CompanyNewModal from "company/new/App";
import { toCompanySmall } from "utilities/companyUtils";
import { LayoutType } from "components/SmallDetails";

interface Props extends ModalPickerProps<server.dto.CompanySmall> {
  modalTitle: string;
  addressType: server.dto.AddressTypes;
  hideEditButton?: boolean;
  layout?: LayoutType;
}

const CompanyModalPicker = (props: Props) => {
  const { modalTitle, addressType, hideEditButton, layout, ...rest } = props;

  const [displayNewCompanyModal, setDisplayNewCompanyModal] = React.useState(false);

  return <>
    {displayNewCompanyModal && <CompanyNewModal
      onClose={() => setDisplayNewCompanyModal(false)}
      onCreated={(c) => {
        props.onChange(toCompanySmall(c));
        setDisplayNewCompanyModal(false);
      }}
    />}
    <ModalPickerWithChooseButton
      onNewClicked={() => setDisplayNewCompanyModal(true)}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={modalTitle}
      modalSize="tiny"
      renderModalContent={(closeModal) => <CompanyList
        addressType={addressType}
        onItemSelected={(company) => {
          closeModal();
          props.onChange(company);
        }}
      />}
      renderRemovable={(innerProps) => <RemovableCompany {...innerProps} hideEditButton={hideEditButton} layout={layout ?? "singleLine"} />}
      {...rest}
    />
  </>;
};

export default CompanyModalPicker;